import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { RecruitmentApplicationService } from '../../../../../core/services/recruitment-application.service';
import { RecruitmentOfferService } from '../../../../../core/services/recruitment-offer.service';
import { ConfigService } from '../../../../../core/utils/config-service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
  selector: 'app-recruitment-workflow',
  templateUrl: './recruitment-workflow.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
  styleUrls: ['./recruitment-workflow.component.css']
})
export class RecruitmentWorkflowComponent {
  search_text = '';
  data: any[] = [];
  offers: any[] = [];
  selectedOfferId: any = null;
  loading = false;

  selected: any = null;
  interview: any = { interview_date: '', interview_location: '', notes: '' };

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private applicationService: RecruitmentApplicationService,
    private offerService: RecruitmentOfferService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.getOffers();
    this.getAll();
  }

  getOffers() {
    this.offerService.getAll().subscribe((res: any) => {
      this.offers = res.data ?? [];
    }, () => {});
  }

  getAll() {
    this.loading = true;
    this.applicationService.getByOffer(this.selectedOfferId).subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Workflow de recrutement', err); });
  }

  onOfferChange() {
    this.pg.p = 0;
    this.getAll();
  }

  openDetail(application: any, content: any) {
    this.selected = application;
    this.interview = {
      interview_date: application.interview_date ?? '',
      interview_location: application.interview_location ?? '',
      notes: application.notes ?? ''
    };
    this.modalService.open(content, { size: 'lg' });
  }

  setState(state: number) {
    if (!this.selected) return;
    this.applicationService.setState(this.selected.id, state).subscribe((res: any) => {
      this.toastrService.success(res.message);
      this.selected.status = state;
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => AppErrorShow.showError('Workflow de recrutement', err));
  }

  planInterview() {
    if (!this.selected) return;
    if (!this.interview.interview_date) {
      this.toastrService.warning('La date d\'entretien est requise');
      return;
    }
    this.applicationService.setStateWithBody(this.selected.id, 2, this.interview).subscribe((res: any) => {
      this.toastrService.success(res.message);
      this.selected.status = 2;
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => AppErrorShow.showError('Workflow de recrutement', err));
  }

  hire() {
    if (!this.selected) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Embauche', 'Confirmer l\'embauche de ce candidat ? Un membre du personnel sera créé.');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.applicationService.hire(this.selected.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.modalService.dismissAll();
          this.getAll();
        }, (err: any) => AppErrorShow.showError('Workflow de recrutement', err));
      }
    });
  }

  delete(application: any) {
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment supprimer cette candidature ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.applicationService.delete(application.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.getAll();
        }, (err: any) => AppErrorShow.showError('Workflow de recrutement', err));
      }
    });
  }

  cvUrl(application: any): string {
    const f = application?.cv_file;
    if (!f) return '';
    if (typeof f === 'string' && (f.startsWith('http://') || f.startsWith('https://'))) return f;
    return ConfigService.toFile('storage/recruitment/' + f);
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  statusLabel(s: number) {
    return ['Soumise', 'Présélectionnée', 'Entretien', 'Retenue', 'Rejetée'][s] ?? 'Soumise';
  }
  statusClass(s: number) {
    return ['bg-blue-100 text-blue-700', 'bg-indigo-100 text-indigo-700', 'bg-amber-100 text-amber-700', 'bg-green-100 text-green-700', 'bg-red-100 text-red-700'][s] ?? 'bg-blue-100 text-blue-700';
  }
}
